import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'

import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import Toast from 'primevue/toast'
import ConfirmPopup from 'primevue/confirmpopup'
import ToastService from 'primevue/toastservice';
import ButtonGroup from 'primevue/buttongroup'
import Select from 'primevue/select';
import 'primeicons/primeicons.css';
import '@fontsource-variable/inter/opsz.css';
import '@fontsource/jetbrains-mono/400.css';
import '@/assets/styles.scss';
import { i18n } from './plugins/i18n'
import './plugins/navigation'
import FileUpload from 'primevue/fileupload'
import Tooltip from 'primevue/tooltip';
import ColumnResizeDirective from './plugins/column-resizer';

import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';

const app = createApp(App);

// Define custom preset with navigation blue as primary color
const OrticPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '#044072',
            600: '#03395f',
            700: '#02294d',
            800: '#021a3a',
            900: '#010c28',
            950: '#010820'
        }
    }
});

app.config.devtools = true
app.use(store)
app.use(router);
app.use(i18n)
app.use(ToastService);
app.use(ConfirmationService);
app.use(PerfectScrollbarPlugin)

app.directive('column-resize', ColumnResizeDirective);
app.directive('tooltip', Tooltip);

app.use(PrimeVue, {
    theme: {
        preset: OrticPreset,
        options: {
            //darkModeSelector: '.app-dark'
        }
    }
});
app.component('FileUpload', FileUpload)
app.component('Toast', Toast)
app.component('ConfirmPopup', ConfirmPopup)
app.component('ButtonGroup', ButtonGroup)
app.component('Select', Select)



// Global paste handler for numeric inputs to support formats like 5'154.23
window.addEventListener('paste', (e) => {
    const target = e.target;
    if (!target || (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA')) return;

    const text = (e.clipboardData || window.clipboardData).getData('text');
    if (!text) return;

    // Detect if this is likely a numeric field
    const isNumericField = 
        target.type === 'number' || 
        target.getAttribute('inputmode') === 'decimal' ||
        target.closest('.p-inputnumber') ||
        target.classList.contains('p-inputnumber-input') ||
        target.classList.contains('text-right');

    if (isNumericField && (text.includes("'") || text.includes("\u2019") || text.includes(" "))) {
        // Clean: remove quotes, spaces, and normalize comma to dot
        const sanitized = text.replace(/['\u2019\s]/g, '').replace(',', '.');
        const numericOnly = sanitized.replace(/[^-0-9.]/g, '');
        
        if (numericOnly && !isNaN(numericOnly) && numericOnly.trim() !== '') {
            e.preventDefault();
            
            // Set value and trigger events
            target.value = numericOnly;
            
            // Dispatch multiple events to ensure framework detection
            const events = ['input', 'change'];
            events.forEach(type => {
                target.dispatchEvent(new Event(type, { bubbles: true }));
            });

            // Modern InputEvent
            target.dispatchEvent(new InputEvent('input', {
                bubbles: true,
                cancelable: true,
                data: numericOnly,
                inputType: 'insertFromPaste'
            }));

            // Extra tick for PrimeVue/Vue internal state synchronization
            setTimeout(() => {
                if (target.value !== numericOnly) {
                    target.value = numericOnly;
                    target.dispatchEvent(new Event('input', { bubbles: true }));
                }
            }, 0);
        }
    }
}, true);

app.mount('#app');

